/**
 * Directives - Web Components                                                                              Directives - Web Components
 * ************************************************************************************************************************************
 */
const angular = require('angular');
require('../../node_modules/angular-ui-scroll/dist/ui-scroll.min');
require('../../node_modules/angular-ui-scroll/dist/ui-scroll-jqlite.min');
require('./vendor/angular-scroll-watch.min');
require('./vendor/angular-count-to.min');
require('./vendor/getScreenId');
require('../../node_modules/ng-tags-input/build/ng-tags-input.min');

var app = angular.module('learn-directives', [
  'ui.scroll',
  'ui.scroll.jqlite',
  'pc035860.scrollWatch',
  'countTo',
  'ngTagsInput'
]);

require('./directives/access_profile/access-profile-manager');
require('./directives/access_profile/add-profile-users');
require('./directives/access_profile/profile-selector');
require('./directives/access_profile/profile-users-list');
require('./directives/access_profile/segmentation-selection');
require('./directives/activity-feed');
require('./directives/add-user-multiple');
require('./directives/add-user-single');
require('./directives/admin-badges-list');
require('./directives/admin-overview-charts');
require('./directives/admin-top-nav');
require('./directives/admin-user-assigned');
require('./directives/admin-user-overview');
require('./directives/admin-user-reports');
require('./directives/admin-user-tracks');
require('./directives/admin-user-viewed');
require('./directives/admin-user-workshops');
require('./directives/admin-user-badges');
require('./directives/answer-question');
require('./directives/api-applications-manager');
require('./directives/archived-manager');
require('./directives/article-viewer');
require('./directives/assign-collaborators');
require('./directives/assessments/admin-user-assessment');
require('./directives/assessments/assessment-host');
require('./directives/assessments/assessment-video-upload');
require('./directives/assessments/assessment-viewer');
require('./directives/assessments/assessments-manager');
require('./directives/assessments/assign-graders');
require('./directives/assessments/file-question-presenter');
require('./directives/assessments/grade-score');
require('./directives/assessments/grader-dashboard');
require('./directives/assessments/grader-instructions');
require('./directives/assessments/horizontal-bar-chart');
require('./directives/assessments/likert-scale');
require('./directives/assessments/normal-distribution-chart');
require('./directives/assessments/outstanding-scores-list');
require('./directives/assessments/question-builder');
require('./directives/assessments/question-manager');
require('./directives/assessments/question-presenter');
require('./directives/assessments/question-answer-presenter');
require('./directives/assessments/user-assessments-list');
require('./directives/assessments/rubric-chart');
require('./directives/assessments/rubric-editor');
require('./directives/assessments/video-question-builder');
require('./directives/assessments/file-question-builder');
require('./directives/assessments/video-question-presenter');
require('./directives/assign-content');
require('./directives/assignments/assignments-manager');
require('./directives/assignments/assignment-templates-manager');
require('./directives/assignments/assignment-templates-search');
require('./directives/assignments/assignment-content');
require('./directives/assignments/assignment-dynamic-message');
require('./directives/assignments/assignment-dynamic-scheduler');
require('./directives/assignments/assignment-escalators');
require('./directives/assignments/assignment-messaging');
require('./directives/assignments/assignment-settings');
require('./directives/assignments/distribute-assignment-template');
require('./directives/assignments/edit-assignment');
require('./directives/assignments/edit-assignment-template');
require('./directives/avatar-crop');
require('./directives/avatar-display');
require('./directives/avatar-image-editor');
require('./directives/avatar-uploader');
require('./directives/bar-chart');
require('./directives/badge-search');
require('./directives/beta-icon');
require('./directives/category-collection');
require('./directives/category-editor');
require('./directives/category-input');
require('./directives/category-selector');
require('./directives/category-transfer');
require('./directives/categories/category-search');
require('./directives/certificate');
require('./directives/change-buddy');
require('./directives/change-manager');
require('./directives/check-image');
require('./directives/chip-content-search');
require('./directives/partners-permission-select');
require('./directives/chip-segmentation-search');
require('./directives/circlestat');
require('./directives/cms/add-categories');
require('./directives/cms/add-certificate');
require('./directives/cms/add-cohort-manager');
require('./directives/cms/add-content-modal');
require('./directives/cms/add-date-set');
require('./directives/cms/add-edit-images');
require('./directives/cms/add-file');
require('./directives/cms/add-duration');
require('./directives/cms/add-list-users');
require('./directives/cms/add-location');
require('./directives/cms/add-manage-vtt');
require('./directives/cms/add-question');
require('./directives/cms/add-scorm');
require('./directives/cms/add-tags');
require('./directives/cms/add-topics');
require('./directives/cms/add-video');
require('./directives/cms/archive-content-failed-modal');
require('./directives/cms/category-restricted-select');
require('./directives/cms/comment-configuration');
require('./directives/cms/content-privacy');
require('./directives/cms/course-selection');
require('./directives/cms/description-editor');
require('./directives/cms/email-body-editor');
require('./directives/cms/event-prework');
require('./directives/cms/image-editor');
require('./directives/cms/leave-page-box');
require('./directives/cms/light-editor');
require('./directives/cms/manager-configuration');
require('./directives/cms/rating-configuration');
require('./directives/cms/related-events');
require('./directives/cms/slack-channel-list');
require('./directives/cms/show-news');
require('./directives/cms/single-image-editor');
require('./directives/cms/site-selector');
require('./directives/cms/track-section');
require('./directives/cms/upload-image');
require('./directives/comment-count');
require('./directives/contenteditable');
require('./directives/content-feedback');
require('./directives/content-host');
require('./directives/content-host-assignments');
require('./directives/content-rating-feedback');
require('./directives/delete-assignment');
require('./directives/date-format');
require('./directives/scorm-host-registrations');
require('./directives/content-host-views');
require('./directives/content-inner-viewer');
require('./directives/content-integration-config');
require('./directives/content-liked-by');
require('./directives/content-manager');
require('./directives/content-top-bar');
require('./directives/content-like-unlike');
require('./directives/content-picker');
require('./directives/content-searchbar');
require('./directives/continu-scroll');
require('./directives/content-survey-searchbar');
require('./directives/continu-template-parser');
require('./directives/copy-button');
require('./directives/custom-copy-manager');
require('./directives/custom-line-chart');
require('./directives/custom-video-player');
require('./directives/dynicon');
require('./directives/edit-buttons');
require('./directives/embedded-video-player');
require('./directives/event-assign-wait');
require('./directives/event-host');
require('./directives/event-viewer');
require('./directives/exiting-app');
require('./directives/explore-container');
require('./directives/explore-order');
require('./directives/explore-people-search');
require('./directives/explore-search');
require('./directives/explore-topbar');
require('./directives/explorer-grid');
require('./directives/file-uploader');
require('./directives/file-viewer');
require('./directives/filtered-content-search');
require('./directives/froala-viewer');
require('./directives/google-analytics-settings');
require('./directives/google-calendar');
require('./directives/google-picker');
require('./directives/google-redirect');
require('./directives/groups/group-categories');
require('./directives/groups/group-list-search');
require('./directives/groups/groups-manager');
require('./directives/groups/group-users-list');
require('./directives/groups/user-groups-search');
require('./directives/host-buttons');
require('./directives/image-lightbox');
require('./directives/image-placeholder');
require('./directives/imported-content-host');
require('./directives/imported-content-host-registrations');
require('./directives/imported-content-viewer');
require('./directives/imported-content-status');
require('./directives/imported-content-registration-display');
require('./directives/inbox-button');
require('./directives/integrations-collection');
require('./directives/inverted-messages');
require('./directives/invitations-manager');
require('./directives/joined-search');
require('./directives/journey-viewer');
require('./directives/journeys/journey-list');
require('./directives/journeys/journey-search');
require('./directives/journey-host');
require('./directives/linkedin-learning-importer');
require('./directives/main-comments');
require('./directives/main-nav');
require('./directives/manage-categories');
require('./directives/manager/add-group-manager');
require('./directives/manager/assign-reports');
require('./directives/manager/manager-activity');
require('./directives/manager/manager-assessments');
require('./directives/manager/manager-assignment');
require('./directives/manager/manager-assignments');
// require('./directives/manager/manager-assign-content');
require('./directives/manager/manager-dashboard');
require('./directives/manager/manager-user');
require('./directives/manager/manager-user-assignments');
require('./directives/manager/manager-user-categories');
require('./directives/manager/manager-user-editor');
require('./directives/manager/manager-user-scorm');
require('./directives/manager/manager-user-badges');
require('./directives/manager/manager-user-journeys');
require('./directives/manager/manager-users');
require('./directives/manager/update-segmentation');
require('./directives/masterclass-importer');
require('./directives/manual-completion');
require('./directives/media-viewer');
require('./directives/meets-create');
require('./directives/meets-redirect');
require('./directives/mention-text-box');
require('./directives/messaging/dynamic-message-manager');
require('./directives/messaging/dynamic-messaging');
require('./directives/messaging/email-template');
require('./directives/messaging/in-app-template');
require('./directives/messaging/scheduler');
require('./directives/messaging/slack-template');
require('./directives/nav-icons');
require('./directives/pdfjs-view');
require('./directives/peoplesearch-button');
require('./directives/pie-chart');
require('./directives/polls-manager');
require('./directives/polls-results');
require('./directives/preauth/accept-invite');
require('./directives/preauth/accept');
require('./directives/preauth/register-with-userid');
require('./directives/preauth/reset');
require('./directives/preauth/forgot-password');
require('./directives/preauth/invite-code');
require('./directives/preauth/preauth-handler');
require('./directives/preauth/reset-password');
require('./directives/preauth/saml-transition');
require('./directives/preauth/oauth-transition');
require('./directives/preauth/signin-form');
require('./directives/preauth/user-registration');
require('./directives/presentation-viewer');
require('./directives/presentation-inner-viewer');
require('./directives/presentation-slide');
require('./directives/presentation-file-viewer');
require('./directives/scorm-host');
require('./directives/survey-search');
require('./directives/overview/recent-five');
require('./directives/overview/simple-stats');
require('./directives/overview/top-five');
require('./directives/overview/totals-chart');
require('./directives/presentation-existing-content');
require('./directives/presentation-file');
require('./directives/presentation-image');
require('./directives/presentation-video');
require('./directives/quiz-viewer');
require('./directives/rating-viewer');
require('./directives/reading-time');
require('./directives/saml-settings');
require('./directives/scorm-viewer');
require('./directives/slack-settings');
require('./directives/bamboo-settings');
require('./directives/scroll-bottom');
require('./directives/scroll-top');
require('./directives/segmentation-manager');
require('./directives/session-preview');
require('./directives/share-content');
require('./directives/single-comment');
require('./directives/skills-manager');
require('./directives/skills-search');
require('./directives/smart-card');
require('./directives/stripe-settings');
require('./directives/su-modal');
require('./directives/su-multi-select');
require('./directives/su-popup');
require('./directives/su-select');
require('./directives/survey-popup');
require('./directives/suspended-manager');
require('./directives/suspended-display');
require('./directives/theme-settings');
require('./directives/track-host');
require('./directives/track-inner-viewer');
require('./directives/track-viewer');
require('./directives/translations-manager');
require('./directives/udemy-importer');
require('./directives/user-assignments-view');
require('./directives/user-certificates');
require('./directives/user-badges');
require('./directives/user-contextmenu');
require('./directives/user-editor');
require('./directives/user-event-search');
require('./directives/user-likes');
require('./directives/user-limits');
require('./directives/user-passcode-change');
require('./directives/user-profile-display');
require('./directives/user-profile-edit');
require('./directives/user-progress');
require('./directives/user-manager');
require('./directives/user-notifications');
require('./directives/user-notifications-edit');
require('./directives/user-timeline');
require('./directives/user-track-display');
require('./directives/user-tracks-growth');
require('./directives/user-tracks-status');
require('./directives/user-upcoming-events');
require('./directives/user-workshop-display');
require('./directives/user-workshop-search');
require('./directives/user-workshops-status');
require('./directives/users-searchbar');
require('./directives/users-selected');
require('./directives/video-image');
require('./directives/view-more');
require('./directives/view-actions');
require('./directives/vimeo-player');
require('./directives/workflow-category-selection');
require('./directives/workflow-list');
require('./directives/workflow-users-list');
require('./directives/workshop-host');
require('./directives/workshop-instance-host');
require('./directives/workshop-viewer');
require('./directives/workshop-assign-wait');
require('./directives/workshops-manager');
require('./directives/workshops-searchbar');
require('./directives/workshop-type-selection');
require('./directives/ws-instance-zoom-manager');
require('./directives/youtube-player');
require('./directives/zoom-settings');
require('./directives/microsoft-redirect');
require('./directives/microsoft-profile-integration');
require('./directives/multi-session-workshop-viewer');
require('./directives/multi-session-workshop-host');
require('./directives/overview/user-assignments-chart');
require('./directives/survey-viewer');
require('./directives/survey-host');

// React embeds
require('../react/angular/edit-survey-directive');
require('../react/angular/view-survey-directive');
require('../react/angular/popup-survey-directive');
require('../react/angular/chart-overview-directive');
require('../react/angular/host-survey-chart-directive');

/**
 * Defines the Vertical Navigation Menu component/directive
 * @argument {Application} Application injected to gain access to all the global Application functions and properties
 */
app.directive('horizontalMenubar', ['Application', 'Authorization', 'Navigation',  'Analyze','ZendeskWidget',  function (Application, Authorization, Navigation, Analyze, ZendeskWidget) {
    return {
      restrict: 'E',
      scope: {
        menuvisibility: '=',
        usercontextvisibility: '=?',
        setusercontextvisibility: '=?'
      },
      template: require('../templates/directives/horizontal-menubar.html'),
      controller: ['$scope', '$route', '$timeout', 'Navigation', function ($scope, $route, $timeout, Navigation) {
          var self = this;
          self.initials = '';
          self.visible = Authorization.hasValidAuthToken;
          self.authtoken = Authorization.getAuthToken();
          self.smartbar = Application.smartbar;
          self.inbox = false;
          self.supportCenterLocation = Application.supportCenterBrandLocation;
          self.initializedZendeskWidget = false;
          self.support = false;
          self.peoplesearchHandler = () => {
            Navigation.goTo('/people');
          };

          self.hideSupportModal = function () {
            self.support = false;
          };

          self.showSupportModal = function () {
            self.support = true;
            ZendeskWidget.load();
          };

          self.changeMenuVisibility = function (opt) {
            if (opt || opt === false) {
              $scope.menuvisibility = opt;
              return;
            }
            $scope.menuvisibility = !$scope.menuvisibility;
          };

          const ticketingBrand = Application.ticketingBrand;
          self.zendeskSupport = !ticketingBrand.customSupport;
          if (!self.zendeskSupport && ticketingBrand && ticketingBrand.caption) {
            self.customTicketingText = ticketingBrand.caption;
            self.customTicketingLink = ticketingBrand.link;
            self.customTicketingLocation = ticketingBrand.location;
          }

          self.toggleZendesk = function () {
            ZendeskWidget.load(() => {
              ZendeskWidget.display();
            });
          };
          self.home = function () {
            if (Navigation.getPath() === '/explore') {
              Application.categories.set(null);
              $route.reload();
              return;
            }
            Navigation.goToHome();
          };
          self.logout = function () {
            Analyze.record(
              { resource: 'authtokens' },
              { token: Authorization.getAuthToken().token, action: 'signout' }
            );
            Application.analyticsProvider.trackEvent('signout');
            $timeout(function () {
              Authorization.signout();
            }, 1);
          };


          self.user = Authorization.getAuthToken().user;
          self.flags = Application.features.flags();
          if (!self.user) {
           $timeout(function () {
              self.user = Authorization.getAuthToken().user;
            }, 500);
          }

        }
      ],
      controllerAs: 'hmenu'
    };
  }
]);
/**
 * Defines the Vertical Navigation Menu component/directive
 * @argument {Application} Application injected to gain access to the global Application functions and properties
 */
app.directive('verticalMenubar', ['appConfiguration', 'Authorization', 'Intercom', 'Navigation', 'NotificationService', 'UrlLookup', function (appConfiguration, Authorization, Intercom, Navigation, NotificationService, UrlLookup) {
    return {
      restrict: 'E',
      scope: {
        menuvisibility: '='
      },
      template: require('../templates/directives/vertical-menubar.html'),
      transclude: true,
      controller: ['$scope','$route', function ($scope, $route) {
          var self = this;
          self.urlLookup = UrlLookup;
          self.visible = Authorization.hasValidAuthToken;
          self.isAdmin = function () {
            return Authorization.isAdmin();
          };
          self.isCreator = function () {
            return Authorization.isCreator();
          };
          self.isCollaborator = function () {
            return Authorization.isCollaborator();
          };
          self.isManager = function () {
            if (!Authorization.hasValidAuthToken()) {
              return false;
            }
            if (!Authorization.getAuthToken().user) {
              return false;
            }
            return Authorization.getAuthToken().user.is_manager;
          };
          self.isGrader = function () {
            if (!Authorization.hasValidAuthToken()) {
              return false;
            }
            if (!Authorization.getAuthToken().user) {
              return false;
            }
            return Authorization.getAuthToken().user.is_grader;
          };
          self.explore = function (event) {
            self.hideMenu();
            if (Navigation.getPath().startsWith('/explore')) {
              $route.reload();
              event.preventDefault();
              return;
            }
          };
          self.navigateCleanup = function () {
            self.hideMenu();
            NotificationService.updateUserNotifications();
          };
          self.atHome = function () {
            return Navigation.isRoute('/explore') || Navigation.isInRoute('/explore/');
          };
          self.atDashboard = function () {
            return Navigation.isInRoute('/dashboard/');
          };
          self.atOverview = function () {
            var url = Navigation.getPath();
            if (
              Navigation.isRoute('/overview/admin') ||
              /\/edit\/workflows/g.test(url) ||
              /\/hosts\/events/g.test(url)
            ) {
              return true;
            }
          };
          self.atMyreports = function () {
            return Navigation.isInRoute('/manager');
          };
          self.toggleIntercom = function () {
            Intercom.toggle();
          };
          self.atOverviewInner = function () {
            var url = Navigation.getPath();

            if (
              Navigation.isRoute('/overview/admin') ||
              Navigation.isRoute('/overview/content') ||
              Navigation.isRoute('/overview/events') ||
              Navigation.isRoute('/overview/users') ||
              Navigation.isRoute('/overview/events') ||
              Navigation.isRoute('/overview/polls') ||
              Navigation.isRoute('/overview/reports') ||
              Navigation.isRoute('/overview/settings') ||
              Navigation.isRoute('/overview/workflows') ||
              Navigation.isRoute('/overview/workshops') ||
              /\/host\/articles\//g.test(url) ||
              /\/host\/videos\//g.test(url) ||
              /\/host\/files\//g.test(url) ||
              /\/host\/track\//g.test(url) ||
              /\/host\/events\//g.test(url) ||
              /\/host\/workshops\//g.test(url) ||
              /\/host\/imported-content\//g.test(url) ||
              /\/users\/add\/csv\//g.test(url)
            ) {
              return true;
            }
          };
          self.atOverviewAdmin = function () {
            return Navigation.isRoute('/overview/admin');
          };

          self.checkExplore = function () {
            var patt = new RegExp(/^(\/explore)/g);
            var res = patt.test(Navigation.getPath());
            return res;
          };

          self.currentHubLinks = appConfiguration.hubLinks;

          self.hideMenu = function () {
            $scope.menuvisibility = false;
          };

          self.resizeEvent = function () {
            $scope.menuvisibility = false;
          };
          self.initialize = function () {
            window.addEventListener('resize', self.resizeEvent);
          };
          self.initialize();
        }
      ],
      controllerAs: 'vmenu'
    };
  }
]);

/**
 * Configure the ng-tags-input directive
 * @argument tagsInputConfigProvider {tagsInputConfigProvider} tags input config provider
 */
app.config([
  'tagsInputConfigProvider',
  function (tagsInputConfigProvider) {
    tagsInputConfigProvider.setDefaults('tagsInput', { placeholder: '' });
    tagsInputConfigProvider.setActiveInterpolation('tagsInput', { placeholder: true });
  }
]);

/**
 * Browserify Module export
 * @type angular module @exp;app
 */
module.exports = app;
